import fromText from './fromText';
import fromTextArea from './fromTextArea';
import fromTextList from './fromTextList';
import fromTable from './fromTable';
import fromRadio from './fromRadio';
import fromCheckboxes from './fromCheckboxes';

export default props => {
  const { from, onChange, localSchema, localUiSchema, formData } = props;
  const options = localSchema.enum ||
  (localSchema.items && localSchema.items.enum) || ['Option 1', 'Option 2', 'Option 3'];
  const updatedForm = {
    schema: {
      title: localSchema.title,
      type: 'string',
      enum: options
    },
    uiSchema: { 'ui:widget': 'select', 'ui:description': localUiSchema['ui:description'] },
    formData
  };
  switch (from) {
    case 'text':
      onChange(Object.assign({}, updatedForm, fromText(updatedForm)));
      break;
    case 'textArea':
      onChange(Object.assign({}, updatedForm, fromTextArea(updatedForm)));
      break;
    case 'textList':
      onChange(Object.assign({}, updatedForm, fromTextList(updatedForm)));
      break;
    case 'radio':
      onChange(Object.assign({}, updatedForm, fromRadio(updatedForm)));
      break;
    case 'table':
      onChange(Object.assign({}, updatedForm, fromTable(updatedForm)));
      break;
    case 'checkboxes':
      onChange(Object.assign({}, updatedForm, fromCheckboxes(updatedForm)));
      break;
    default:
      break;
  }
};



// WEBPACK FOOTER //
// ./webpack/components/Document/Form/Builder/changeQuestionType/toSelect/index.js